import React, { useState } from "react";
import DropdownList from 'shared/components/DropdownList';
import Item from 'fantastic/components/editor/sidebars/tools/Item';
import { nameByKind } from "fantastic/lib/sections/nameByKind";

import addItem from "fantastic/actions/addItem";
import connectActions from "fantastic/lib/connectActions";
import getItems from "fantastic/lib/items";

const LinkText = () => <i className="fi fi-plus-circle"/>;
const Title = () => <div className="shared-dropdown-list__title">{ i18n.t('empty_item.title') }</div>;

const EmptyItem = ({ addItem, id, columnType }) => {
  const items = getItems();

  const handleItemClick = item => {
    window.target = { id };
    addItem({
      data: item,
      meta: { type: "ITEM/NEW", kind: item.kind },
      itemType: "ITEM/NEW"
    });
  }

  const isCell = columnType == 'CELL';

  return <div className="fantastic-item__empty">
    {!isCell &&
      <>
        <span className="fantastic-item__empty--collapsable" title={i18n.t('empty_item.desc')}>
          <span>{ i18n.t('empty_item.caption_1') }</span>
          <span>{ i18n.t('empty_item.caption_2') }</span>
        </span>
        <DropdownList link={<LinkText />} title={<Title />}>
          {items.map((item, index) => (
            <a key={index} className="btn btn-form shared-dropdown-list__item" onClick={() => handleItemClick(item)}>
              <i className={`fi fi-${item.kind}`} />
              <span>{nameByKind(item.kind)}</span>
            </a>
          ))}
        </DropdownList>
      </>
    }
  </div>;
};

export default connectActions({ addItem })(EmptyItem);
